module.exports = __webpack_public_path__ + "media/images/ceremony/plans/3/estimate_3-91dba009ae7c3f38e61bff7dabf1f6b0.jpg";